import {pick, includes, createSelector} from 'helpers';
import {getCollaboration} from 'store/relations';
import {context} from 'store/common';

export const settings = createSelector(
  state => JSON.stringify(state.settings),
  stringified => ({
    externalCalendars: 'icloud, google',
    shareStatus: 'mine, byMe, withMe',
    ...JSON.parse(stringified)
  }),
);

export const defaultSetting = (name, defaultValue) => state => {
  return state.settings.defaults?.[name] ?? defaultValue;
};

export const appSettings = createSelector(
  state => JSON.stringify(pick(state.settings, 'webVersion', 'firstDayOfWeek', 'googleSyncEnabled')),
  JSON.parse,
);

const shareStatus = createSelector(
  settings,
  settings => settings.shareStatus,
);

export const shareStatusFilter = createSelector(
  [ shareStatus, getCollaboration, context ],
  ( shareStatus, getCollaboration, context ) => ({ id }) => {
    const collaboration = getCollaboration({ id, context });
    const status = collaboration?.self.type == 'Owner' ? 'byMe' : collaboration ? 'withMe' : 'mine';
    return includes(shareStatus, status);
  },
);
